import React, { Component } from 'react';
import { Card, Button, ButtonGroup, Nav, Image, Row, Col, Container, Spinner, Accordion, InputGroup, FormControl } from 'react-bootstrap';
import Axios from "axios";
import M from "materialize-css";
import { EditOutlined, Search, Print, NavigateBefore, NavigateNext, Info, EmojiFlagsRounded, } from "@material-ui/icons";
import { ModalHeader, ModalBody, ModalFooter, Modal  } from 'reactstrap';
import EditOrder from './editCashBillInvoice';
import ProductItemsList from './ProductItemListCard';
import Icon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import { base_url } from '../../globalConstants';
import './orderlist.css';


class OrderList extends Component {
  constructor(props) {

    super(props);

    this.state = ({
      orderslist: this.props.orderdata,
      previouSelectedOrder: "",
      previousSelectedOrderMerge: "",
      productlistforMerge: [],
      orderweights: {},
      ordercustomer: {},
      orderproducts: {},
      totalweight: 0,
      manifestlist: [],
      mergelist: [],
      orderforedit: {},
      customerinfo: {},
      productlist: [],
      productlisthtml: <div></div>,
      parentOrderSelected: null,
      showSpinner: false,
      product_category_options: [],
      searchTerm: '',
      ManifestDisable: false,
      EditOrderDisabled: false,
      statusIDtoName: {},
      orderfilterString:"",

      tempOrderId: "",
      tempOrderId2: "",
      remarksTextValue: "",
      OnHoldValue: {},
      remarksOnHoldList: {},
      isCardAuth: {},

      tempCardAuth:"",
      tempBillingType:"",
      order_response: this.props.orderResponse,

      previousPageUrl: this.props.orderResponse.previous,
      nextPageUrl: this.props.orderResponse.next,
      currentPageNumber: 1,

      currentOrderListCount: this.props.orderdata.length,
      searchResultsCount: -1,
      totalOrderListCount: this.props.orderResponse.count,
      orderlistCopy: this.props.orderdata,
      country_list: this.props.countryList,
      countrycodelist: this.props.country_code_list,
      outboundlist: [],
      fileUrl: '',
      modalFile: false,
      total_amt:0,
      amt_received:0,
      amt_change:0,
      paymentmode:"WIRE"
    })
  }


  componentDidMount() {
    // Auto initialize all the things!
    // @TODO: fetch data from server to show list and update the state orderslist
    M.AutoInit();
  }


  onHoldRemarksEdit = (orderIdTemp) => {


    console.log(this.state.remarksOnHoldList[orderIdTemp]);

    this.setState({
      tempOrderId2: orderIdTemp
    })
    
    var elems = document.getElementById("updateRemarksOnHold");
    var instance = M.Modal.init(elems);
    instance.open()
    return;

  }

  updateOnHoldRemarks = async (tempId) => {

    console.log(tempId);

    let remarksData = this.state.remarksTextValue
    // console.log(remarksData);

    let token = localStorage.getItem("token")
    let header = {
      'Content-Type': 'multipart/form-data',
      'Authorization': 'Token ' + token,

    }
    var config = {
      headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Token ' + token },

    };

    try {

      var remarksOnHold = new FormData()
      remarksOnHold.append("inv_status", "Delivered")

      let remarksOnHoldurl = base_url+`boxes_received/${tempId}/`

      const remarksOnHold_response = await Axios.patch(remarksOnHoldurl, remarksOnHold, config)
      console.log(remarksOnHold_response.data.remarks)
      M.toast({
        html: 'Update Remarks for OrderID: ' + tempId + '<br/> Please refresh' , classes: "white-text blue rounded"
      })

    } catch (error) {
      console.log(error)
      M.toast({ html: 'Failed to add remarks', classes: "white-text orange rounded" });
    }


  }  

  //ON HOLD CHECK

  // //TEMP

  updateOrderList = async (updatedUrl, pg) => {

    var context = this
    var tempPageNumber = this.state.currentPageNumber


    this.setState({
      showSpinner: true,
    })

    // console.log('UPDATED URL',updatedUrl)

    let response_data = []
    var prevUrl 
    var nextUrl 

    await Axios({
      method: "GET",
      url: updatedUrl
    }).then(function(response){
      // console.log("response",response);
      // console.log("response.data.results",response.data.results);
      response_data = response.data.results
      // context.setState({ updatedOrdersList: response.data.results })
      // console.log("UPDATED ORDELIST",this.state.updatedOrdersList);      
      // console.log("UPDATED ORDELIST",response_data);   
      prevUrl = response.data.previous   
      nextUrl = response.data.next   

      // tempPageNumber = updatedUrl.toString().split('=')[1] ?? 1

      if(pg === '+')
        tempPageNumber = tempPageNumber + 1
      else if(pg === '-')
        tempPageNumber = tempPageNumber - 1
      else
        tempPageNumber = ''

      context.setState({
        showSpinner: false,
        currentPageNumber: tempPageNumber
      })
    }).catch(function(response){
      console.log("response",response);
      console.log("ERROR UPDATING ORDERLIST");
    })

    await this.setState({orderslist: response_data})
    this.setState({previousPageUrl: prevUrl})
    this.setState({nextPageUrl: nextUrl})

  }


  nextPageTemp = () => {
    // alert(`NEXT PAGE ${this.state.order_response.next}`)
    // this.props.orderList_url = this.state.order_response.next
    console.log("this.props.orderList_url",this.props.orderList_url);
    console.log("this.state.order_response.next", this.state.order_response.next);

    var tempUrl = this.state.order_response.next
    this.props.orderList_url(tempUrl)

  }


 handleKeyDownSearch=(eventKey)=>{
  //  console.log('orderfilterString',this.state.orderfilterString);
  
  var filterString = this.state.orderfilterString
  let context = this
  if (eventKey.key ==="Enter"){
  this.setState({
    showSpinner: true,
    currentPageNumber: 1
  })

  var orderCount
  var prevUrl    
  var nextUrl    
  var search_results

  let searchUrl = base_url+`boxes_received/?search=${filterString}`   
  Axios({
    method: 'GET',
    url: searchUrl
  }).then( async (response) =>{
    // console.log(response);
    // console.log(response.data.results);
    // console.log(response.data.count);
    // console.log(response.data.next);
    // console.log(response.data.previous);
    
    orderCount = response.data.count
    prevUrl = response.data.previous   
    nextUrl = response.data.next  
    search_results = response.data.results

    context.setState({currentPageNumber: 1})

    if(!response.data.results){
      this.setState({orderslist: []}) 
      this.setState({searchResultsCount: orderCount})
      this.setState({currentOrderListCount: response.data.results.length})
      return
    }

    this.setState({searchResultsCount: orderCount})
    this.setState({orderslist: search_results})
    this.setState({previousPageUrl: prevUrl})
    this.setState({nextPageUrl: nextUrl})
    this.setState({searchResultsCount: orderCount, showSpinner: false})
    
    console.log('orderlist.length', this.state.orderslist.length);
    this.setState({currentOrderListCount: response.data.results.length})
    
  }).catch(  (response) =>{
    console.log(response)
    this.setState({showSpinner:false})
    // M.toast({ html: response.Error, classes: "white-text red rounded" })
   
  })
}
 }

  editSearchTerm = async (e) => {
      // console.log(e.target.value)
      
      let word = e.target.value
      let bucket = word.split(' ')
      
      // console.log(bucket)
      
      let searchString = bucket.reduce((prevVal, currVal)=>{ return prevVal+=currVal+' ' }, ' ')

      console.log('searchString',searchString);
      this.setState({
          orderfilterString:searchString
      })
      
    
      
      // console.log('URL', base_url+`boxes_received/?search=${searchString}`);
      
      // const response=await Axios.get(searchUrl)
      // const {data}=response.results;

      if(searchString ===""){
        this.setState({
          showSpinner: true,
        })
      
        var orderCount
        var prevUrl    
        var nextUrl    
        var search_results
  
        let searchUrl = base_url+`boxes_received/?search=${searchString}`   
        await  Axios({
          method: 'GET',
          url: searchUrl
        }).then( async (response) =>{
          // console.log(response);
          // console.log(response.data.results);
          // console.log(response.data.count);
          // console.log(response.data.next);
          // console.log(response.data.previous);
          
          orderCount = response.data.count
          prevUrl = response.data.previous   
          nextUrl = response.data.next  
          search_results = response.data.results
  
          if(!response.data.results){
            this.setState({orderslist: []}) 
            this.setState({searchResultsCount: orderCount})
            this.setState({currentOrderListCount: response.data.results.length})
            return
          }
  
          this.setState({searchResultsCount: orderCount})
          this.setState({orderslist: search_results})
          this.setState({previousPageUrl: prevUrl})
          this.setState({nextPageUrl: nextUrl})
          this.setState({searchResultsCount: orderCount, showSpinner: false})
          
          console.log('orderlist.length', this.state.orderslist.length);
          this.setState({currentOrderListCount: response.data.results.length})
          
        }).catch(  (response) =>{
          console.log(response)
         this.setState({showSpinner:false})
        //  M.toast({ html: ""+response.Error, classes: "white-text red rounded" })
       
        })
      }
  }

  refreshpage = async () => {
    let token = localStorage.getItem("token")
    let header = {
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + token
    }
    let context = this
    this.setState({
      showSpinner: true,
      orderslist:[],
      mergelist: []
    })

    let url = base_url+`billingdetails/`
    await Axios({
      method: 'GET',
      url: url,
      headers: header
    }).then(function (response) {
      console.log(response.status)
      console.log(response)

      context.setState({
        orderslist: response.data.results,
        showSpinner: false,
        manifestlist: [],
        previouSelectedOrder: ""
      })
      
      context.setState({
        searchResultsCount: -1,
        currentOrderListCount: response.data.results.length,
        totalOrderListCount: response.data.count
      })
      
      M.toast({ html: 'Refreshed ', classes: "white-text green rounded" })
      
    }).catch(function (response) {
      console.log(response)
      M.toast({ html: "Failed to refresh", classes: "white-text red rounded" })
      context.setState({

        showSpinner: false
      })
    })
  }

  getcustomer = async (ezzid) => {
    // http://localhost:8000/api/v1/ezzytrace/products/?order_id=
    try {
      let token = localStorage.getItem("token")
      let header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Token ' + token,

      }

      var url = base_url+`customers/?ezz_id=${ezzid}`
      let customer = await Axios.get(url, header)
      console.log(customer.data.results)


      // M.toast({html: 'Pending Ordersa fetched',classes:"white-text orange rounded"});
      // this.setState({error:<Success/>})
      // this.setState({productlist: this.state.productlist})
      this.setState({ customerinfo: customer.data.results[0] })


    } catch (error) {
      console.log(error)
      M.toast({ html: 'Failed to fetch cutomer details', classes: "white-text red rounded" });
      // this.setState({error:<Error/>})
    }
  }


  click = () => {
    this.props.orderList();
  }

  openeditordermodal = async (order) => {
    await this.setState({ orderforedit: order });
    await this.getoutboundno()
    this.refs.editorder.openModal(this.state.outboundlist);

  }

  getoutboundno = async () => {
    //alert("get")
    try {
      let token = localStorage.getItem("token")
      var config = {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Token ' + token },

      };

      var url = base_url+`getOutBoudNoByDate?from=${this.state.orderforedit.from_date}&to=${this.state.orderforedit.to_date}&country=${this.state.orderforedit.country}&billing_id=${this.state.orderforedit.billing_id}`
      let products = await Axios.get(url, config)
      console.log(products.data)
      // await this.setState({productlisthtml:<ProductItemsList products={new Array()}/>})
      var items = new Array()
      var i = 0;
      products.data.forEach((productmain) => {
        let isExist = false;
        let sbillid = '';
        if (productmain.billing_id == null)
        {
          sbillid = '';
        }
        else{
          sbillid = productmain.billing_id;
        }
        if (sbillid.toString().length > 5)
        {
          isExist = true;
        }
        let svalue = productmain.box_id + "/" + productmain.box_weight + "/" + productmain.unit_charge
        let newitem = {value: svalue, label: productmain.outbound_tracking_number, isChecked: isExist}
        items.push(newitem)
        i = i + 1
      })

      M.toast({ html: 'Fetched AWB for selected range', classes: "white-text orange rounded" });
      await this.setState({ outboundlist: items })
      //console.log(outboundlist)
    } catch (error) {
      console.log(error)
      M.toast({ html: 'Failed to fetch AWB', classes: "white-text red rounded" });
      // this.setState({error:<Error/>})
    }
  } 

  openviewordermodal = async (order) => {


    await this.getproducts(order.order_id)
    await this.getcustomer(order.ezz_id)
    await this.setState({ orderforedit: order });

    let country = this.state.customerinfo.country
    await this.getCategories(country)

    let productcatgry = this.state.product_category_options
    let products = this.state.productlist
    console.log("orderlistopent", products)
    //this.refs.vieworder.openModal(products, productcatgry);

  }

DownloadInvoice = async (orderDetails) => {

    var currentOrderId = "Invoice_" + orderDetails.billing_id //"CASH-170" 

    var invoiceFormData = new FormData()
    invoiceFormData.append("invoice", currentOrderId)

    await Axios({
      method: "POST",
      url: base_url+`/download_billing_invoice`,
      data: invoiceFormData,
      responseType: 'blob'
    }).then((response)=>{
      console.log("RESPONSE DONE", response);  
      console.log("RESPONSE DONE", response.data);  
      console.log("RESPONSE DONE", response.headers['content-type']);  
      const file_url = window.URL.createObjectURL(new Blob([response.data], {type:'application/pdf'}));
      console.log("fileURL",file_url);
      this.setState({fileUrl: file_url})
      this.setState({modalFile: true})
    }).catch((response)=>{
      console.log("RESPONSE NOT DONE", response);        
      M.toast({html: `Error while Downloading.`,classes: "white-text red rounded"})
    })
  }
// checkUploadedInvoice = async (orderDetails) => {
  sendnotification = async(order) =>{
    var result = window.confirm("Are you sure want to send notification!");
    if (result == false) {
      return;
    }
    let email_subject = '';
    if (order.payment_status === 'Due')
    {
      email_subject = "billing_invoicing"        
      const  emaildata= {"type" : email_subject,
        "billing_id" : order.billing_id}
        
      Axios({
          method:'post',
          url: base_url+'send_email1/',
          data: emaildata,
        }).then(
          function(response){ 
          console.log(response)
          M.toast({html: 'Email Sent to '+response.data["Email to"],classes:"white-text green rounded"});
          
          }
        ).catch(
          function(response){ 
          console.log(response)
          M.toast({html: 'Email Sent to '+response,classes:"white-text red rounded"});
          }
        )
        await this.refreshpage();
    }
    else{
      M.toast({
        html: `Notification not allowed for this billing `,
        classes: "white-text orange rounded"
      });
    }
      
    }
  
onChangeOnHoldCheckTwo = (event, paramorder) => {
    var e = event.target
    var totamt = 0
    totamt = parseFloat(paramorder.total_amount)  
    var amtrec = 0
    if (paramorder.payment_received != null)
    { 
      amtrec =  parseFloat(paramorder.payment_received)
    }
    var amtbal = totamt - amtrec
    var pmode = ""
    if (paramorder.payment_mode == null)
    {
        pmode = "WIRE"
    }
    else{
        pmode = paramorder.payment_mode
    }

    this.setState({
      tempOrderId2: paramorder.billing_id,
      tempOrderId: paramorder.id,
      total_amt: parseFloat(totamt).toFixed(2),
      amt_received: parseFloat(amtrec).toFixed(2),
      amt_change: parseFloat(amtbal).toFixed(2),
      paymentmode: pmode
    })
        var elems = document.getElementById("remarksForOnHold");
        var instance = M.Modal.init(elems);
        instance.open()
      return;

  }

  handleChange = async (ev)=>{   
    this.setState({
      [ev.target.name]: ev.target.value
    })
  }

handleCustomerIDChange = async (ev)=>{       
      const target = ev.target;
      const name = target.name;


      this.setState({
        [name]: target.value
      })

      if (name == "amt_received")
      {
          this.setState({
          amt_change: parseFloat(this.state.total_amt) - parseFloat(target.value)
        })
      }
}

onHoldRemarks = () => {


    var temp_orderId = this.state.tempOrderId
    console.log(temp_orderId);
    this.statusOnHoldRemarks(temp_orderId)

  }


  statusOnHoldRemarks = async (tempId) => {

    console.log(tempId);
    let remarksData2 = this.state.remarksTextValue
    console.log(remarksData2);

    let token = localStorage.getItem("token")
    let header = {
      'Content-Type': 'multipart/form-data',
      'Authorization': 'Token ' + token,

    }
    var config = {
      headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Token ' + token },

    };

    try {
      var today = new Date();
      var dd = today.getDate();

      var mm = today.getMonth()+1; 
      var yyyy = today.getFullYear();
      if(dd<10) 
      {
        dd='0'+dd;
      } 

      if(mm<10) 
      {
        mm='0'+mm;
      }
      today = yyyy+'-'+mm+'-'+dd;
      console.log("today date: " + today)
      var paystatus = "Due";
      var remarksOnHold = new FormData()
      if (parseFloat(this.state.total_amt) == parseFloat(this.state.amt_received))
      {
        paystatus = "Paid"
      }
      if (paystatus == "Paid")
      {
        remarksOnHold.append("status", "Closed")
      }
      remarksOnHold.append("payment_status", paystatus)
      remarksOnHold.append("payment_received", this.state.amt_received)
      remarksOnHold.append("payment_on", today)
      remarksOnHold.append("payment_mode", this.state.paymentmode)

      let remarksOnHoldurl = base_url+`billingdetails/${tempId}/`

      const remarksOnHold_response = await Axios.patch(remarksOnHoldurl, remarksOnHold, config)
      console.log(remarksOnHold_response.data.remarks)
      M.toast({
        html: 'Payment Received for BillingID: ' + this.state.tempOrderId2 + '<br/> Please refresh' , classes: "white-text blue rounded"
      })
      await this.refreshpage();
      //alert("refresh page")
    } catch (error) {
      console.log(error)
      M.toast({ html: 'Failed to receive payment', classes: "white-text orange rounded" });
    }


  }

  render() {

    var idNo = 0
	var total_due = 0
	var inv_amt = 0
    
    const orderCardList = this.state.orderslist.map((order) => {
    idNo = idNo + 1
	  total_due = order.total_amount
	  total_due = parseFloat(total_due).toFixed(2)
	  inv_amt =	parseFloat(order.payment_received).toFixed(2)
      return (
        <div>

                {(() => {
                    // Function to set icons with respect to order status
                    // if (order.current_status !== "NEW") {
                    if ((order.invoice_num !== "") &&  (order.invoice_num !== null)) {

                      return (


                        <>
                        
                        <Card key={order.id} className="orderItemdetailsCard">
            <Card.Header className="smallheader">
              <Row >
                <Col sm={4} md={4} lg={3}>
                  <Card.Text>{order.billing_id}</Card.Text>
                </Col>
                <Col >
                  <Card.Text>{order.email_owner}</Card.Text>
                </Col>
                <Col  >
                  <Card.Text >
                    {order.country}
                  </Card.Text>
                </Col>
                <Col>
                  <Card.Text>
                    {order.from_date}
                  </Card.Text>
                </Col>
                {/*<Col>
                  <Card.Text>
                    {order.outbound_number}
                  </Card.Text>
                </Col>*/}
              </Row>
              <Row>
                {/*<Col>
                  {(() => {
                    // Function to set icons with respect to order status
                    if (order.current_status === "DISC") {

                      return (<p className="red-text"><Image className="ml-1" src="assets/images/wrong.svg" /> {order.current_status_name}</p>)
                    }
                    else {
                      return (<p className="black-text"><Image className="ml-1" src="assets/images/dot.svg" /> {order.current_status_name}</p>)
                    }




                  })()}
                </Col>*/}
                <Col className=" ">

                &nbsp;&nbsp;
                <Accordion.Toggle className="right inline alignmore_details" as={Nav.Link} variant="link" eventKey={order.id}>
                    More Details<Image className="ml-1 " src="assets/images/plus-circlesmall.svg" />
                  </Accordion.Toggle>

                  {/* @TODO loading for manifest must be implemented */}
                  
                 
                </Col>
              </Row>

            </Card.Header>


            <Card.Body>


      
    
    
    
                  <Accordion.Collapse eventKey={order.id}>
    
                    <Card.Body>
                      <Row>
					    <Col  >
                              <h6>Customer Info</h6>
                              Name: {order.email_owner}<br></br> 
                              Email: {order.email_to}<br></br>    
                              Mobile No.: {order.email_phone}         <br></br>       
                              {/* Payment Type: {order.billing_type}<br></br>
                              Insurance Fee: {order.inv_insurance_fee}<br></br>
                              Consolidation Fee: {order.inv_processing_fee}<br></br>                      */}
                      
                        </Col>
                        <Col  >
                              <h6>Invoice Info</h6>
                              From Date: {order.from_date}<br></br> 
                              To Date: {order.to_date}<br></br>    
                              Name: {order.invoice_num}<br></br>
                              {/* Brokerage Fee: {order.inv_handling_fee}<br></br>
                              Home Delivery: {order.inv_homedelivery_fee}<br></br>                      */}
                        </Col>
                        <Col>
                               <h6>Payment Info</h6>
                              Total Due: {total_due}<br></br> 
                              Paid: {inv_amt}<br></br>    
                              Balance: {(total_due-inv_amt).toFixed(2)}<br></br>
                              Status: {order.payment_status}<br></br>
                              PaidOn: {order.payment_on}<br></br>     
                        </Col>
               
    

    
                        <Col>
                          <Nav className="right">
    
                            <ul>
                             
                                  <>
                                    <li><Nav.Link className="red-text modal-trigger " onClick={() => this.openeditordermodal(order)}  >
                                      View Invoice<Image className="red-text ml-1" src="assets/images/edit.svg" /></Nav.Link></li>
                                    <li><Nav.Link className="green-text modal-trigger " onClick={() => this.DownloadInvoice(order)}  >
                                      View PDF <Print /></Nav.Link></li>
                                      {
                                      order.payment_status == "Paid" 
                                ? ""
                                :      <li><Nav.Link className="blue-text modal-trigger " onClick={(e)=>this.onChangeOnHoldCheckTwo(e,order)}  >
                                      Capture Payment <Image className="red-text ml-1" src="assets/images/edit.svg" /></Nav.Link></li>
                                      }
                                      {
								                    order.payment_status == "Due" 
                                ?
                                  <li><Nav.Link className="black-text modal-trigger " onClick={() => this.sendnotification(order)} >
                                  Send Notification <Info /></Nav.Link></li>
                                :
                                  ""  
	                      						}

                                      {/* {
                                      order.payment_status == "Delivered" 
                                ? ""
                                :      
                                      <li><Nav.Link className="blue-text modal-trigger " onClick={() => this.onHoldRemarksEdit(order.order_id)}   >
                                      Mark Delivered <Image className="red-text ml-1" src="assets/images/edit.svg" /></Nav.Link></li>
                                      } */}
                                  </>
                                
                            </ul>
                          </Nav>
                        </Col>
                      </Row>
                      
    
                    </Card.Body>
                  </Accordion.Collapse>
    
                </Card.Body>
    
              </Card>


                </>
              )

            }
          })()}
          
        </div>
      );
      
    });

    return (
      <Container>


        {
          this.state.showSpinner
            ? < div className="center">

              <Spinner animation="grow" variant="primary" size="sm" />
              <Spinner animation="grow" variant="success" size="sm" />
              <Spinner animation="grow" variant="warning" size="sm" />
            </div>
            : null
        }

        <>

         {/* ADD NEW REMARKS  */}
          <div id="remarksForOnHold" className="modal remarksForOnHold  modal-fixed-footer">
            <div className="modal-content ">
              <div className="">


                <h4 className="center orange-text"> Update Cash Payment </h4>

                <form  >
                  <div className="row ">
                    <div className="col  s6 l6">
                      <h6> Billing Id: {this.state.tempOrderId2 }</h6>

                      {(() => {
                          return (
                            <>

<Row>
                    <Col xs={9}>
                        <h5 >Total Amount to pay(In USD):</h5> 
                        </Col>
                        <Col xs={3}><input disabled name="total_amt" id="total_amt" type="text" 
            value={this.state.total_amt} 
            onChange={this.handleCustomerIDChange}
            onKeyDown={this.handleCustomerInfo}
          />
                    </Col>
                    </Row>
                    <Row>
                    <Col xs={9}>
                        <h5 >Amount Received(In USD):</h5> 
                        </Col>
                        <Col xs={3}><input name="amt_received" id="amt_received" type="text" 
            value={this.state.amt_received} 
            onChange={this.handleCustomerIDChange}
            onKeyDown={this.handleCustomerInfo}
          />
                    </Col>
                    </Row>
                    
                   
                        <Row>
                    <Col xs={9}>
                        <h5 >Change(In USD):</h5> 
                        </Col>
                        <Col xs={3}><input disabled name="amt_change" id="amt_change" type="text" 
            value={this.state.amt_change} 
            onChange={this.handleCustomerIDChange}
            onKeyDown={this.handleCustomerInfo}
          />
                    </Col>
                    </Row>
                    <Row>
                    <Col xs={9}>
                        <h5 >Payment Mode:</h5> 
                        </Col>
                        <Col xs={3}><select id="paymentmode" name="paymentmode" className="browser-default paymentmode" value={this.state.paymentmode} onChange={this.handleChange}>
                        <option value="WIRE"  >WIRE</option>
						            <option value="Authorize"  >Authorize</option>
                    </select>
                    </Col>
                    </Row>

                              {/*<label htmlFor="remarksText2">
                                Remarks:
                              </label>
                              <textarea
                                id="remarksText2"
                                className=""
                                name=""
                                value={this.state.value}
                                onChange={this.handleChangeRemarksText}
                                placeholder={this.props.placeholder} />*/}

                            </>                          
                          )
                      })()}

                    </div>
                  </div>


                </form>
              </div>
            </div>
            <div className="modal-footer">

              <ButtonGroup className="mr-2" aria-label="First group">
                {/*<Button id="saveRemarksModalBtn" variant="outline-primary" type="submit" className="mr-2 btn modal-close" onClick={this.onHoldRemarks} >Print Receipt</Button>*/}
                <Button id="closeRemarksModalBtn" variant="outline-secondary" className="mr-4 btn modal-close "  >Cancel Payment</Button>
                <Button id="saveRemarksModalBtn" variant="outline-primary" type="submit" className="mr-2 btn modal-close"  onClick={this.onHoldRemarks} >Confirm Payment</Button>
              </ButtonGroup>
            </div>
          </div>


          <div id="parentOrderModel" className="modal parentOrderModel  modal-fixed-footer">
            <div className="modal-content ">
              <div className="">


                <h4 className="center orange-text"> Parent Order </h4>



                <form >


                  <div className="row ">
                    <div className="col  s6 l6">
                      {/* Order Status Radio Buttons */}
                      <h5>Select Parent Order</h5>
                      {(() => {


                        return this.state.mergelist.map((ordernumber, index) => {

                          return (
                            <p key={index}>
                              <label>
                                <input name="parentOrderSelected" value={ordernumber} type="radio"
                                  checked={this.state.parentOrderSelected === ordernumber} onChange={this.handleParentOrderChange} />
                                <span><b>Order Number.</b> {ordernumber}</span>
                              </label>
                            </p>


                          )

                        })



                      })()}
                      {/* { this.state.parentboxSelected} */}

                    </div>
                  </div>


                </form>
              </div>
              {this.state.parentOrderSelected}
            </div>
            <div className="modal-footer">

              <ButtonGroup className="mr-2" aria-label="First group">
                <Button id="closeEditBoxBtn" variant="outline-secondary" className="mr-4 btn modal-close "  >Close</Button>
                <Button id="mergeOrderBtn" variant="outline-primary" className="mr-2 btn modal-close"
                  onClick={this.mergeOrders} > Proceed</Button>
              </ButtonGroup>
            </div>
          </div>


          {/* ON HOLD MODAL */}

                     {/* ADD NEW REMARKS  */}
          <div id="remarksForOnHold" className="modal remarksForOnHold  modal-fixed-footer">
            <div className="modal-content ">
              <div className="">


                <h4 className="center orange-text"> Remarks </h4>

                <form  >
                  <div className="row ">
                    <div className="col  s6 l6">
                      <h5>Please give reason for On Hold <p style = {{ fontSize : "11px" }} >Order Id: {this.state.tempOrderId }</p></h5>

                      {(() => {
                          return (
                            <>

                              <label htmlFor="remarksText">
                                Remarks:
                              </label>
                              <textarea
                                id="remarksText"
                                className=""
                                name=""
                                value={this.state.value}
                                onChange={this.handleChangeRemarksText}
                                placeholder={this.props.placeholder} />

                            </>                          
                          )
                      })()}

                    </div>
                  </div>


                </form>
              </div>
            </div>
            <div className="modal-footer">

              <ButtonGroup className="mr-2" aria-label="First group">
                <Button id="closeRemarksModalBtn" variant="outline-secondary" className="mr-4 btn modal-close "  >Cancel</Button>
                <Button id="saveRemarksModalBtn" variant="outline-primary" type="submit" className="mr-2 btn modal-close" onClick={this.onHoldRemarks} >Save</Button>
              </ButtonGroup>
            </div>
          </div>

                      {/* UPDATE REMARKS */}

          <div id="updateRemarksOnHold" className="modal updateRemarksOnHold  modal-fixed-footer">
            <div className="modal-content ">
              <div className="">
                <h4 className="center orange-text">Update Status</h4>

                

                <form  >
                  <div className="row ">
                    <div className="col  s6 l6">
                      <h5 className="center blue-text"> Are you sure want to mark cash invoice status Delivered? </h5>

                    

                    </div>
                  </div>


                </form>
              </div>
            </div>
            <div className="modal-footer">

              <ButtonGroup className="mr-2" aria-label="First group">
                <Button id="closeRemarksModalBtn" variant="outline-secondary" className="mr-4 btn modal-close "  >Cancel</Button>
                <Button id="saveRemarksModalBtn" variant="outline-primary" type="submit" className="mr-2 btn modal-close" 
                onClick= { () => this.updateOnHoldRemarks(this.state.tempOrderId2)} >Confirm</Button>
              </ButtonGroup>
            </div>
          </div>
          

          {/* ON HOLD MODAL */}


        </>


        <div className="row">
          <div className="col s3">
            <h4 className=" orange-text">Cash Invoice Listing </h4>
          </div>

          <div className="col s4">

          </div>

          {/* <div className="col s7 l7 offset-4 offset-l4">                       */}
          <div className="col s7 l7 ">                      
            {/* hide Manifest button because we not using selection things RN */}

            {/*<ButtonGroup>
              <Button variant="outline-secondary " className="grey white-text mr-2" onClick={this.refreshpage}>Refresh </Button>
              <Button variant="outline-primary " className="indigo white-text mr-2" onClick={this.selectParentOrder}>Merge </Button>
              {this.state.ManifestDisable ? <Button disabled variant="outline-primary " className="orange white-text " onClick={this.manifestOrders}>Manifest</Button> : <Button variant="outline-primary " className="orange white-text " onClick={this.manifestOrders}>Manifest</Button>}
            </ButtonGroup>*/}

          </div>
        </div>

        <Row>
          <Col>
            <div>
                {
                  this.state.previousPageUrl
                    ? <Button variant="outline-secondary " title="Previous Page" className="teal white-text mr-2" onClick={() => this.updateOrderList(this.state.previousPageUrl,'-')} ><NavigateBefore /></Button>
                    : <Button variant="outline-secondary " title="Previous Page" className="teal white-text mr-2" disabled><NavigateBefore /></Button>
                }
                {
                  this.state.nextPageUrl
                    ? <Button variant="outline-secondary " title="Next Page" className="teal white-text mr-2" onClick={() => this.updateOrderList(this.state.nextPageUrl,'+')}><NavigateNext /></Button>
                    : <Button variant="outline-secondary " title="Next Page" className="teal white-text mr-2" disabled><NavigateNext /></Button>
                }          
            </div><br/>
            <div>              
                {
                  this.state.currentPageNumber  != ''
                  ?<h5>Page: {this.state.currentPageNumber}</h5>
                  :""
                }              
            </div>
          </Col>
          <Col>
            <div>
              <InputGroup className="mb-3" style={{ float: 'right', width: '270px' }}>
                <InputGroup.Prepend >
                  <InputGroup.Text style={{ border: '1px solid grey', background: 'white' }} id="inputGroup-sizing-default"><Search /></InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  style={{ border: '1px solid gray', borderRadius: '2px', paddingLeft: '10px' }}
                  aria-label="Default"
                  aria-describedby="inputGroup-sizing-default"
                  placeholder="  Search here....."
                  onChange={this.editSearchTerm.bind(this)}
                  onKeyDown={this.handleKeyDownSearch}
                // onKeyUp={this.onKeyDown}
                />
              </InputGroup>
            </div><br/>
            

          </Col>
        </Row>

        <Row>
          <Col xs={6} md lg={6}>
            

          </Col>
          <Col xs={6} md lg={6}>

          </Col>
        </Row>
        {/* country_list: this.props.countryList,
      countrycodelist: this.props.country_code_list, */}
        {/* {console.log("orderlist productlist", this.state.productlist)} */}
        <EditOrder orderdata={this.state.orderforedit} outboundlist={this.state.outboundlist}
        
          ref="editorder" country_list={this.props.countryList} countrycodelist={this.props.country_code_list} refresh={this.props.refresh} refreshpage={this.refreshpage}  />

        {/* <ViewOrder orderdata={this.state.orderforedit} customerinfo={this.state.customerinfo}
          productlist={this.state.productlist} productlisthtml={this.state.productlisthtml}
          ref="vieworder" refresh={this.props.refresh} refreshpage={this.refreshpage} productCategory={this.state.product_category_options} /> */}

        <Row>
          <Col xs={12} sm={12} lg={12}>
            <div >

              <div id="orderlistdiv" >
                <Row id=" orderlistrow">
                  <Col>
                    <p> <Image className="mr-1" src="assets/images/down.svg" />Invoice Number</p>
                  </Col>
                  <Col>
                    <p className="center"> <Image className="mr-1" src="assets/images/down.svg" />Customer</p>
                  </Col>
                  <Col>
                    <p> <Image className="mr-1" src="assets/images/down.svg" />Country</p>
                  </Col>
                  <Col >
                    <p className="left"> <Image className="mr-1" src="assets/images/down.svg" />Invoice Date</p>
                  </Col>
                  {/*<Col >
                    <p> <Image className="mr-1" src="assets/images/down.svg" />Outbound No.</p>
                  </Col>*/}

                </Row>
                <div className="divider"></div>
              </div>
              <div className="orderlistwrapperdiv">

                <Accordion>
                  <form>
                    {orderCardList}
                  </form>

                </Accordion>
              </div>


            </div>
          </Col>


        </Row>

        <Modal id="fileView" className = "fileView" size="lg" isOpen={this.state.modalFile} >
        <ModalBody>

          <iframe name="my-frame" id="my-frame" title="my-frame" src={this.state.fileUrl} style={{ width: '100%', height: '100vh' }} ></iframe>

        </ModalBody>
        <ModalFooter>
          <Button onClick={()=>this.setState({modalFile: false}) } variant="outline-primary" className='mr-2'>Close</Button>{''}
          <Button onClick={()=>{window.frames["my-frame"].print()}} variant="primary">Print</Button>
        </ModalFooter>
      </Modal>         

      </Container>

    )
  }
}

export default OrderList;
